import { render } from "./GroupedConfigPanel.vue?vue&type=template&id=452cb9d4&scoped=true"
import script from "./GroupedConfigPanel.vue?vue&type=script&lang=js"
export * from "./GroupedConfigPanel.vue?vue&type=script&lang=js"

import "./GroupedConfigPanel.vue?vue&type=style&index=0&id=452cb9d4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-452cb9d4"]])

export default __exports__